import React from 'react';

const Frame = () => {

return (
  <>
    <section id="container" className="wrap">
      <div className="paragraph">
        <h1 className="subject"><strong>SKYTONE</strong></h1>
        <h2 className="title">프레임 조립</h2>
        <p className="desc">스카이톤 조립은 크게 두 가지로 나뉩니다.<br/>
          모듈 조립과 액자 조립 입니다.<br/>
          조립을 위해서는 별도의 공구가 필요 하지 않습니다.
        </p>
      </div>   
      <div className="page-content">
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">01</p>
            <p className="desc">프레임 부품을 확인해 주세요.</p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/frame-01.png'} alt=""/>
          </div>       
        </div>      
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">02</p>
            <p className="desc">조립 순서는 아래와 같습니다. (후면 기준)</p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/frame-mov.gif'} alt=""/>
          </div>       
        </div>  
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">03</p>
            <p className="desc">프레임에 아래와 같이 층층이 겹쳐 넣습니다.<br/><small>* 부품에 포함된 보호비닐은 모두 제거해 주세요.</small></p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/frame-layer.png'} alt=""/>
          </div>       
        </div>   
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">04</p>
            <p className="desc"><i className="mark"><img src={process.env.PUBLIC_URL + '/src/mark-d.png'} alt="D"/></i> USB Type-C 단자를 모듈에 꼽고, 아래와 같이 선을 정리하여 하단으로 빼줍니다.</p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/frame-module-wide.jpg'} alt=""/>
          </div>      
        </div>    
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">05</p>
            <p className="desc">조립이 끝났습니다! USB 단자를 전원에 연결해주세요.<br/><small>* 극소량의 전력(약 0.5Wh)을 사용하는 제품 특성상,<br/>일부 어댑터 및 보조 배터리에서는 전력이 차단될 수 있습니다.</small></p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/frame-complete.jpg'} alt=""/>
          </div>       
        </div>   
        <div className="content-group">                        
          <div className="paragraph">
            <p className="step">06</p>
            <p className="desc">핑크색으로 깜빡이는 것은 네트워크 연결이 없다는 신호입니다.<br/>Wi-Fi 설정 페이지에서 네트워크 설정을 해주세요.</p>
          </div>
          <div className="screenshot w100">
            <img src={process.env.PUBLIC_URL + '/skytone_src/light-nosignal.png'} alt=""/>
          </div>
        </div> 
      </div>
      <span className="empty-space"></span>
    </section>
  </>
  );
};
export default Frame;